import {computed, inject, Injectable} from '@angular/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {LicencePlanService} from '../../../../api';
import {LicencePlanSelect} from '../../../../api/models';
import {QueryKey} from '../../../constants/query-key';

@Injectable({providedIn: 'root'})
export class LicencePlanStore {
  private readonly licencePlanService = inject(LicencePlanService);

  private readonly licencePlansQuery = injectQuery(() => ({
    queryKey: [QueryKey.LICENCE_PLAN_SELECT],
    queryFn: () => lastValueFrom(this.licencePlanService.getLicencePlanSelect()),
  }));

  licencePlans = computed<LicencePlanSelect[]>(() => this.licencePlansQuery.data()?.licencePlans ?? []);
  isDataLoading = computed(() => this.licencePlansQuery.isLoading());
}
